<template>
  <router-link to="/" class="link-back">&larr; Home</router-link>
  <h2>Watering Schedules</h2>
  <button
    v-for="gate in gates"
    :key="gate.gate"
    @click="showGate(gate.gate)"
  >
    Gate {{ gate.gate }}
  </button>
  <div v-for="gate in gates" :key="gate.gate">
    <gate-weeks
      v-if="activeGate === gate.gate"
      :gate="gate.gate"
    >
    </gate-weeks>
  </div>
</template>

<script>
export default {
  inject: ['gateData'],
  data() {
    return {
      gates: this.gateData,
      activeGate: this.gateData[0].gate
    }
  },
  methods: {
    showGate(gateNum) {
      this.activeGate = gateNum;
    }
  }
}
</script>

<style scoped>
button {
  padding: 5px 15px;
  border: 2px solid var(--blue-100);
  border-radius: 15px;
}
</style>